"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unpack = exports.just = exports.constant = void 0;
/**
 * Create a function that returns a value after being called.
 * @param x the value to be returned
 */
function constant(x) {
    return () => x;
}
exports.constant = constant;
exports.just = constant;
/**
 * Extract the payload element from the object and return it.
 * @example
 * ```
 * match(object, {
 *     ...
 *     case: unpack,
 *     ...
 * })
 * ```
 */
const unpack = (x) => x.payload;
exports.unpack = unpack;
